module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-list-button-group"
  }, [_vm._t("default"), _vm._v(" "), (_vm.showMore) ? _c('div', {
    staticClass: "button-group-more"
  }, [_c('el-popover', {
    ref: "popover",
    attrs: {
      "trigger": "hover",
      "popper-class": "rtElPopover"
    },
    on: {
      "show": _vm.moveBtns
    }
  }, [_c('rt-button', {
    staticClass: "rt-button-more",
    attrs: {
      "slot": "reference",
      "text": "",
      "type": "plain"
    },
    slot: "reference"
  }, [_vm._v("更多")])], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d618a0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/business/list/rtListButtonGroup.vue
// module id = 1510
// module chunks = 91